<template>
  <div>
    <headline code="titre-soumission"></headline>
    <ressource code="texte-soumission" hide-if-empty></ressource>

    <div class="mt-6">
      <v-btn x-large dark color="#3a3838" @click="submit">Soumettre</v-btn>
    </div>
    <opq-alert type="warning" class="mt-6" code="formulaire-incomplet" max-width="700" v-show="showAlert"></opq-alert>
  </div>
</template>

<script>
import { mapGetters } from "vuex"
import FormSimple from "@/mixins/FormSimple"
export default {
  mixins: [FormSimple],

  props: {
    showAlert: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    ...mapGetters(["sas"]),
  },

  methods: {
    submit() {
      this.$emit("submit")
    },
  },
}
</script>

<style></style>
